import React, { useContext } from 'react';
import { Modal } from "react-bootstrap";
import { TranslationContext } from "../../contexts/TranslationContext";
import { CreateUserForm } from './CreateUserForm';
import { LoginForm } from './LoginForm';
import "./LoginModal.scss"

export function LoginModal(props: {
    onLoggedIn: () => void,
    onClose?: () => void
}) {


    const tc = useContext(TranslationContext);

    return (
        <Modal onHide={props.onClose}
            show
            animation={false}
            centered
            scrollable
            size="xl"
            className="login-modal" >
            <Modal.Header
                closeButton
                closeLabel={tc.translator("modal close label", "Luk")}>
                <Modal.Title>
                    {tc.translator("login modal header", "Login eller opret bruger")}
                </Modal.Title>
            </Modal.Header>

            <Modal.Body>
                <div className="splitter">
                    <LoginForm onLoggedIn={props.onLoggedIn} />

                    <CreateUserForm onUserCreated={props.onLoggedIn} />
                </div>
            </Modal.Body>
        </Modal>
    );
}
